import React, { useEffect, useState } from 'react';
import './Footer.css';

interface FooterLinkItem {
  label: string;
  href: string;
}

function parseFooterLinks(configKey: string, config: Record<string, unknown>): FooterLinkItem[] {
  const list = Array.isArray(config[configKey]) ? (config[configKey] as unknown[]) : [];
  return list
    .filter(
      (d: unknown) =>
        d &&
        typeof d === 'object' &&
        typeof (d as { label?: unknown }).label === 'string' &&
        typeof (d as { href?: unknown }).href === 'string' &&
        String((d as { href: string }).href).trim() !== ''
    )
    .map((d: unknown) => ({
      label: (d as { label: string }).label,
      href: (d as { href: string }).href,
    }));
}

export const Footer: React.FC = () => {
  const [docs, setDocs] = useState<FooterLinkItem[]>([]);
  const [instructions, setInstructions] = useState<FooterLinkItem[]>([]);

  useEffect(() => {
    fetch('/config.json')
      .then((res) => res.json())
      .then((config) => {
        setDocs(parseFooterLinks('footer-documents', config));
        setInstructions(parseFooterLinks('footer-instructions', config));
      })
      .catch(() => {
        setDocs([]);
        setInstructions([]);
      });
  }, []);

  return (
    <footer className="site-footer">
      <div className="site-footer-inner">
        <div className="site-footer-docs">
          <div className="site-footer-section">
            <h3 className="site-footer-section-title">Документы</h3>
            <ul className="site-footer-docs-list">
              {docs.map((doc, index) => (
                <li key={`doc-${index}`}>
                  <a href={doc.href} target="_blank" rel="noreferrer">
                    {doc.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
          {instructions.length > 0 && (
            <div className="site-footer-section site-footer-section-instructions">
              <h3 className="site-footer-section-title">Инструкции</h3>
              <ul className="site-footer-docs-list">
                {instructions.map((item, index) => (
                  <li key={`instr-${index}`}>
                    <a href={item.href} target="_blank" rel="noreferrer">
                      {item.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          )}
          <div className="site-footer-info">
            <div className="site-footer-info-title">Самозанятый</div>
            <div className="site-footer-info-name">Лукьянова Анна Михайловна</div>
            <div className="site-footer-info-inn">ИНН 730205254220</div>
          </div>
        </div>
      </div>
    </footer>
  );
};

